import DOMPurify from 'dompurify';
 
export const domPurify = (html: string): string => DOMPurify.sanitize(html);
 
export const checkDomPurify = (html: string): boolean => {
  const sanitizedHtml = DOMPurify.sanitize(html);
  return sanitizedHtml === html; // Returns true if sanitized content is unchanged, otherwise false
 };
 export const purifyHTML = (html: string): string => {
  const sanitizedHtml = DOMPurify.sanitize(html);
  return sanitizedHtml; // Returns true if sanitized content is unchanged, otherwise false
 };